import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Container } from './styles';

import { ChangePassword } from '../../_layouts/default/components/';

function OperacaoAlretarSenha() {

  const { profile } = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);

  const [password, setPassword] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      handleFormPassword()
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  async function handleFormPassword() {
    setPassword(true);   
  }


  return (
    <>
      <Container>
      <ChangePassword password={password} close={() => setPassword(false)} />
        

      </Container>
    </>
  );
}

export default OperacaoAlretarSenha;